import apiClient from "../../axios/apiClient";

export const getInjuryTypeList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_INJURYTYPELIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Injury-Type`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_INJURYTYPELIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_INJURYTYPELIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveInjuryTypeData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_INJURYTYPE_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Injury-Type`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_INJURYTYPE_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_INJURYTYPE_REJECTED", payload: error.response });
    }
  };
  

  export const getInjuryTypeListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_INJURYTYPELISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Injury-Type/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_INJURYTYPELISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_INJURYTYPELISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateInjuryTypeData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_INJURYTYPE_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Injury-Type/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_INJURYTYPE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_INJURYTYPE_REJECTED", payload: error.response });
  }
};


export const updateInjuryTypeStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_INJURYTYPE_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-Injury-Type-Status/${id}`, // Endpoint URL with vehicle ID
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_INJURYTYPE_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_INJURYTYPE_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteInjuryTypeData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_INJURYTYPE_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Injury-Type/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_INJURYTYPE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_INJURYTYPE_REJECTED", payload: error.response });
  }
};